import React, { useEffect, useState } from 'react';
import { Button } from '../components/ui/button';
import { Menu, X } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import LangToggle from './LangToggle';
import ClockChangeBanner from './ClockChangeBanner';

export default function Navbar() {
  const { t } = useI18n();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: t.nav.gathering, href: '#gathering' },
    { label: t.nav.sermons, href: '#sermons' },
    { label: t.nav.studies, href: '#studies' },
    { label: t.nav.prayer, href: '#prayer' },
    { label: t.nav.give, href: '#give' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-[#f5efe3] border-b ${scrolled ? 'border-[#e5dcc5] shadow-[0_8px_24px_-18px_rgba(31,58,42,0.35)]' : 'border-transparent'}`}
    >
      <ClockChangeBanner />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
        <a href="#top" className="flex items-center group">
          <img
            src="/planted-logo.png"
            alt="Planted Ministries"
            className="h-16 lg:h-20 w-auto group-hover:scale-105 transition-transform origin-left"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-[#1f3a2a]/80 hover:text-[#1f3a2a] link-underline transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <LangToggle dark={false} />
          <Button asChild className="bg-[#2e5340] hover:bg-[#1f3a2a] text-[#f5efe3] rounded-full px-5 h-10">
            <a href="#rsvp">{t.nav.rsvp}</a>
          </Button>
          <Button asChild className="bg-[#d4a63d] hover:bg-[#b88a2a] text-[#1f3a2a] rounded-full px-5 h-10">
            <a href="#give">{t.nav.give}</a>
          </Button>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <LangToggle dark={false} />
          <button onClick={() => setOpen(!open)} className="text-[#1f3a2a]" aria-label="Menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#f5efe3] border-t border-[#e5dcc5] px-6 py-6 space-y-4">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="block text-[#1f3a2a] text-base"
            >
              {n.label}
            </a>
          ))}
          <div className="flex gap-3 pt-3">
            <Button asChild className="flex-1 bg-[#2e5340] hover:bg-[#1f3a2a] text-[#f5efe3] rounded-full">
              <a href="#rsvp" onClick={() => setOpen(false)}>{t.nav.rsvp}</a>
            </Button>
            <Button asChild className="flex-1 bg-[#d4a63d] hover:bg-[#b88a2a] text-[#1f3a2a] rounded-full">
              <a href="#give" onClick={() => setOpen(false)}>{t.nav.give}</a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
